// --------------------------------------------------------------------------
// numberField.js
// --------------------------------------------------------------------------
// Replicate functionality of input type="number" with branded UI
// --------------------------------------------------------------------------

RN.numberField = function() {

  'use strict';

  function init() {
    byBehaviour('number-field').each(function(){
        new numberField($(this));
    });
  }

  var numberField = function(el){
    this.increaseEl = el.find('[data-element="increase"]');
    this.decreaseEl = el.find('[data-element="decrease"]');
    this.inputEl = el.find('[data-element="input"]');
    this.min = this.inputEl.data('min') || 0;
    this.max = this.inputEl.data('max') || 999;
    this.value = parseInt(this.inputEl.val());
    this.setDisableDecrease();
    this.setDisableIncrease();
    this.registerEvents();
  }

  numberField.prototype.registerEvents = function(){
    var self = this;
    this.increaseEl.on('click', function(){
        self.increase();
        return false;
    });
    this.decreaseEl.on('click', function(){
        self.decrease()
        return false;
    });
    this.inputEl.on('keydown', function(e){
        return self.numberOnlyInput(e);
    });
  }

  numberField.prototype.setDisableIncrease = function(){
    this.value === this.max
    ? this.increaseEl.prop('disabled', true)
    :   this.increaseEl.prop('disabled', false);
  }

  numberField.prototype.setDisableDecrease = function(){
    this.value === this.min
    ? this.decreaseEl.prop('disabled', true)
    : this.decreaseEl.prop('disabled', false);
  }

  numberField.prototype.increase = function(){
    this.value++;
    this.inputEl.val(this.value);
    this.setDisableDecrease();
    this.setDisableIncrease();
    $(this.inputEl).trigger('change');
  }

  numberField.prototype.decrease = function(){
    this.value--;
    this.inputEl.val(this.value);
    this.setDisableDecrease();
    this.setDisableIncrease();
    $(this.inputEl).trigger('change');
  }

  numberField.prototype.numberOnlyInput = function(e){
    var pressed = e.which,
        numberKeyPressed = (pressed >= 48 && pressed <= 57),
        otherAllowedKeys = [37, 39, 8, 9, 46],
        otherAllowedKeyPressed = otherAllowedKeys.indexOf(pressed) > -1;

    if (!numberKeyPressed && !otherAllowedKeyPressed){
        return false;
    }
  }

  return {
    init: init
  };

}();